import { Group } from "@/types";
import { MobileRaiseType } from "../mobile-raise-templates/types";

export interface SettingsState {
	allPrefTypes: PrefType[];
	allIcons: any[];
	allGroups: any[];
	allPrefs: Pref[];
	selectedGroup: Group;
}
export interface PrefType {
	prefTypeID: PrefTypesEnum;
	title: string | null;
	description: string | null;
	dataType: string | null;
	systemOnly: boolean;
	hidden: boolean;
	category: string | null;
	link: string | null;
	orderNum: number | null;
	parent: string | null;
	feature: string | null;
	value: any | null;
}
export interface Pref {
	prefID: number;
	prefTypeID: PrefTypesEnum;
	value: string;
	groupID: number | null;
}
export interface IconSet {
	iconSetID: number;
	title: string;
	groupID: number | null;
	iconData: string;
	typeID: number | null;
	manualRaiseType: MobileRaiseType | null;
}
export interface PrefTypeRequest {
	prefTypeID: PrefTypesEnum;
	groupID: number | null;
}

export const enum PrefTypesEnum
{
	DatabaseVersion = 0,
	SMTPServer = 1,
	SMTPPort = 2,
	SMTPUsername = 3,
	SMTPPassword = 4,
	ErrorEmailAddress = 5,
	DaysToKeepEventFiles = 6,
	DaysToKeepEvents = 7,
	StationName = 8,
	StationAddress = 9,
	StationTimezone = 10,
	SystemMessage = 11,
	ReceiveSMTP = 12,
	AmtServerAddress = 13,
	VcgServerAddress = 14,
	RunawayIgnoreMode = 15,
	HeitelCamControlServer = 16,
	AllowWinAuth = 17,
	ShowstaffPassword = 18,
	DeviceChangesSave = 19,
	UseRecovery = 20,
	RecordFPS = 21,
	ShowMessageOnLogin = 22,
	AllowMultiSystemLogin = 23,
	AllowPasswordChange = 24,
	EveryoneCanProcessTrouble = 25,
	ProcessWithButtonOnly = 26,
	ForceScriptCompletion = 27,
	TourHold = 28,
	MultiSelectAcknowledgement = 29,
	NoAcknowledgement = 30,
	AutoplayAttachedFiles = 31,
	Playbackspeed = 32,
	Lockplaybackspeed = 33,
	ShowGPF = 34,
	ShowconnectedTo = 35,
	DefaultTab = 36,
	ShoweEdge = 37,
	MaxDisarm = 38,
	SmsFinder = 39,
	MapActionBoxBorderOnly = 40,
	AllowInstantUnpark = 41,
	ShowStaffPasswords = 42,
	ImmixProxyLocation = 43,
	ReportsServiceLocation = 44,
	AuditServiceLocation = 45,
	DefaultLockoutPeriod = 46,
	PasswordResetThreshold = 47,
	License = 48,
	AdminServiceAddress = 49,
	AlarmAcknowledgementNotRequired = 50,
	LenelOnguardServerAddress = 51,
	VideofiedServiceLocation = 52,
	XMLHeartbeat = 53,
	NewsRsslocation = 54,
	FailedLoginMaxAttempts = 55,
	FailedLoginLockoutMinutes = 56,
	UsernameMinLength = 59,
	DisablePasswordComplexity = 60,
	AllowAutoProcess = 61,
	AutoProcessOutcome = 62,
	AutoProcessRoutingGroup = 63,
	EmailAddressLogin = 67,
	UserActivityThreshold = 68,
	WarnLastOperatorLogout = 69,
	HideSystemQueue = 70,
	LastBackup = 71,
	DisarmedOnlyEdge = 72,
	ConnectionFailureThreshold = 73,
	SerialAlarmGrouping = 74,
	AlarmTagGrouping = 75,
	AlarmPriorityGrouping = 76,
	WallProxyLocation = 77,
	MaxWallWidthHeight = 78,
	DomainControllerServers = 79,
	DisableSitecheck = 80,
	LastSystemUpdate = 81,
	IgnoreAspectRatio = 82,
	HideWallTitles = 83,
	DoNotAutoshowCamera = 90,
	NumberOfAlarmFrames = 91,
	RecordQuality = 92,
	Enablecameralinking = 93,
	WallAlarmPriority = 94,
	WallVerificationNote = 95,
	WallVerificationPriority = 96,
	AlarmClipRepeats = 97,
	AlarmClipTimeout = 98,
	UnlinkedAlarmMultiview = 99,
	LicenseLastUpdated = 100,
	AlertCPUPercent = 101,
	AlertRAMPercent = 102,
	AlertDrivePercent = 103,
	MultipleAlarmAcknowledgementDisabled = 104,
	HandleOtherUsersEvents = 105,
	ShowDirectionsOnAlarmMap = 106,
	MultiWindowAlarmProcessing = 107,
	AlarmAlertsSuppressFlashing = 109,
	SMTPUsesSSL = 110,
	DoNotRequireMouseHoldForTours = 111,
	UnrestrictedMapActions = 112,
	WebInterfaceHostAddress = 113,
	UserPermissionsCache = 114,
	MultiviewMaxWidth = 115,
	MultiviewMaxHeight = 116,
	PlaybackStepDuration = 117,
	AutoplayMultiviewCameras = 118,
	SystemIdentifier = 119,
	EventForwarding = 120,
	DoNotShowOutcomeNotes = 122,
	ShowPreviousEventsFromDay = 123,
	ShowIncidentConfirmationBox = 124,
	AddNoteToEventPark = 125,
	IgnoreMultiviewAspectRatio = 126,
	CanOpenActiveEvent = 127,
	EndpointCacheValid = 128,
	GroupsFilestoreCacheUpdated = 129,
	ShowSiteTreeCollapsed = 132,
	AutoReconnectLimit = 134,
	SMTPSaveEmails = 135,
	ColourCodeAlarmQueue = 139,
	EventInactivityTimeout = 141,
	EventInactivityWarning = 142,
	AllowOperatorsFullNotesPermissions = 150,
	AlarmScreenTimeout = 151,
	SessionTimeout = 152,
	PasswordResetDays = 153,
	DeviceServiceAddress = 154,
	PasswordIncorrectWindow = 155,
	AlarmAgeWarningSeconds = 156,
	EnforcePasswordComplexity = 157,
	NumberOfPreviousPasswordsToCheck = 158,
	AlertNetworkPercent = 159,
	ClickToDialHistoryLength = 160,
	AuditReportCreation = 161,
	ConsecutiveCharactersMatchingFromPassword = 162,
	HideOriginalMaps = 163,
	ShowRoadViewForEnhancedMap = 164,
	RemovePointsOfInterestFromEnhancedMaps = 165,
	GoogleMapsApiKey = 166,
	Maplayersmodelvaliditypoint = 167,
	Enableptzvideowall = 168,
	GAAmodelValidityPoint = 169,
	GAARecordTime = 170,
	GAAClosestRadiusCameras = 171,
	GAAAssumeElevation0 = 172,
	RequestControlCountDownDuration = 173,
	RequestControlWarningDuration = 174,
	RequestControlGiveControlByDefault = 175,
	Quickfiltereventrecordtype = 176,
	QuickFilterOfInEventSectionDisabled = 177,
	Sessionlifespanminutes = 182,
	DisableDataIndicatorOnHtml5Player = 193,
	MaintainersSiteStaffInherit = 199,
	PrefCacheValidityPoint = 200,
	DarkTheme = 201,
	DisableQueueStatus = 202,
	DonTDefaultEventOutcomes = 203,
	AllowExternalUsers = 204,
	AllowRegionalDataserviceCommunication = 205,
	MapFloorHeight = 206,
	DefaultV2ParkTime = 209,
	RequireParkNote = 210,
	ReportsDataServiceShardLocation = 212,
	HideRestoreAlarms = 213,
	DoorOnlyQuickControl = 214,
	CycleThroughCamerasInPatrols = 215,
	AreaCamerasInTour = 216,
	NearbyCamerasInTour = 217,
	RequiredManualTourNote = 218,
	HideReportCredentials = 219,
	FileSizeUploadLimit = 220,
	ViewsPlaybackTimestamp = 221,
	UseMechanicalPtzByDefault = 222,
	RequiredManualRaisePinDrop = 223,
	MinimumMediaMatrixFileSize = 224,
	CanUsersAddIndividualActions = 225,
	AlarmPointsDoNotLoadEventsAutomatically = 226,
	AccountCreationAllowed = 227,
	ManualRaiseNextEventNum = 228,
	NearbyCamerasRadius = 229,
	EventSearchAscend = 230,
	SecureLdapsPort = 231,
	LocalRegionUrl = 232,
	StaticMapIcons = 233,
	LiveVideoDelay = 234,
	RaiseByPointGrouped = 235,
	RaiseByResponseGrouped = 236,
	CustomerLicense = 237,
	DynamicLinkRegex = 238,
	DynamicLinkFormat = 239,
	MaxCameras = 240,
	MaxCameraDuration = 241,
	MaxCameraDistance = 242,
	ShowBannerForPriority = 243,
	DaysToKeepReportFiles = 244,
	DaysToKeepReports = 245,
	IncludeDrilldownInCsvs = 246,
	InsightsFilterAlarmPointsByAreas = 247,
	MaxWorkers = 248,
	InsightsGenericDateDisplay = 249,
	CaseSyncLock = 250,
	CaseURL = 251,
	IncidentProcessorDisabled = 252,
	SystemLoggingDisabled = 253,
	ToursExpandedByDefault = 254,
	ClipsExpandedByDefault = 255,
	CamerasExpandedByDefault = 256,
	ControlsExpandedByDefault = 257,
	AreasExpandedByDefault = 258,
	RequireMapPinOnAlarm = 259,
	DispatchChangeGuardTypeFromMap = 260,
	DispatchChangeGuardTypeFromMenu = 261,
	EventSearchResultsInUserTime = 262,
	PasswordComplexityMinUppercaseCount = 263,
	PasswordComplexityMinSpecialCharacterCount = 264,
	PasswordComplexityMinLength = 265,
	PasswordComplexityMinNumberCount = 266,
	FilterCCureEvents = 267,
	CollapseParentCategoryByDefault = 268,
	FilesExpandedByDefault = 269,
	EnableAntiForgeryChecks = 270,
	EnableLoginDomainSelection = 271,
	AllowUsersToLoginWithoutADomain = 272,
	UnparkEventOnNewGuardMessage = 273,
	HoldToTransmit = 274,
	Allowemptyaddressesonareas = 275,
	ShowServerName = 276,
	DaysToKeepUserSessionHistory = 277,
	AlwaysAddAlarmsOverPriority = 278,
	SSOEndpoint = 279,
	SSOClientId = 280,
	SSOProviderType = 281,
	SSOClientSecret = 282,
	SSOEnabled = 283,
	SSOAutoRedirect = 284,
	SSORedirectUrl = 285,
	EnableEventClaiming = 286,
	SSOTokenUsernameField = 287,
	IntercomEnabled = 288,
	TrakaRequestCooldown = 289,
	QuickControlMaxCameraRecordDuration = 290,
	CCureReaderGroupCflUpdateReason = 291,
	FirstTwoUserEmail = 293,
	FirstTwoLocationEndpoint = 294,
	QuickControlReaderGroupWarningRegex = 295,
	QuickControlReaderGroupWarningMessage = 296,
	IntercomGreenCallWaiting = 297,
	IntercomAmberCallWaiting = 298,
	IntercomRedCallWaiting = 299,
	StickyHeaderEventConfiguration = 300,
	AdditionalActionsOnForceRestoredAlarms = 301,
	DaysToKeepExpiredInsightsShares = 302,
	DisplayDateInEventSearchResults = 303,
	Disablecamerarecording = 304,
	InsightChartColors = 305,
	ESRIReportAuthToken = 306,
	AlarmAlertsSuppressAudio = 307,
	ViewsMapsPluginZoomManagement = 308,
	CCureMaxPostProcessAttempts = 309,
	SendEventsInPostProcessingToAllRegions = 310,
	SSOSAMLEndpoint = 311,
	ShowHiddenDeviceTypes = 312,
	DisplayEndDialogTestEvents = 313,
	DateTimerevertchangeSiteArmStatus = 315,
	ViewsDefaultGridSize = 319,
	QuickControlPulseWord = 320,
	DuressModalTimeoutDuration = 321,
	DisableDefaultDuress = 322,
	LiveVideoConnectionAttemptMaximumDuration = 323
}
